<div class="range-container">
  <div class="input-boxes">
    <mat-form-field class="hide-subscript" appearance="outline">
      <mat-label i18n="@@range-filter.min-label">Min</mat-label>
      @if (this.isCurrencyField()) {
        <span class="currency" matPrefix>{{currency()?.symbol}}</span>
      }
      <input
        [attr.data-qa-id]="'filterRangeMin' + filterId()"
        matInput
        type="number"
        [(ngModel)]="selectedRange[0]"
        (change)="handleChange()"
        data-testid="min-input"
      />
    </mat-form-field>
    <mat-form-field class="hide-subscript" appearance="outline">
      <mat-label i18n="@@range-filter.max-label">Max</mat-label>
      @if (this.isCurrencyField()) {
        <span class="currency" matPrefix>{{currency()?.symbol}}</span>
      }
      <input
        [attr.data-qa-id]="'filterRangeMax' + filterId()"
        matInput
        type="number"
        [(ngModel)]="selectedRange[1]"
        (change)="handleChange()"
        data-testid="max-input"
      />
    </mat-form-field>
  </div>
  <div class="slider">
    <mat-slider [min]="minMaxValues[0]" [max]="minMaxValues[1]" [step]="1">
      <input
        matSliderStartThumb
        [(ngModel)]="selectedRange[0]"
        (dragEnd)="handleChange()"
        data-testid="min-slider"
      />
      <input
        matSliderEndThumb
        [(ngModel)]="selectedRange[1]"
        (dragEnd)="handleChange()"
        data-testid="max-slider"
      />
    </mat-slider>
  </div>
  @if (this.isCurrencyField()) {
    <div class="minmax">
      <span class="min">{{ minMaxValues[0] | currency : currency()?.code : 'symbol-narrow' : '1.0-0' }}</span>
      <span class="max">{{ minMaxValues[1] | currency : currency()?.code : 'symbol-narrow' : '1.0-0' }}</span>
    </div>
  }
  @if (!this.isCurrencyField()) {
    <div class="minmax">
      <span class="min">{{ minMaxValues[0] }}</span>
      <span class="max">{{ minMaxValues[1] }}</span>
    </div>
  }
</div>
